<template>
  <div class="record-item">
    <ul>
        <li>ID：<a>{{ SafeItem.id }}</a></li>
        <li>名称：<a>{{ SafeItem.nickname }}</a></li>
        <li style="border: none;">今日流水：<a>{{ SafeItem.today_coded_vol }}</a></li>
        <li style="border: none;">
            <div style="width: 80%;margin: 10px auto;text-align: center;
                background: linear-gradient(#cca352, #cbb788);
                border-radius: 10px;
            "
            @click="parentToshow(0)"
            >授权代理</div>
        </li>
    </ul>

  </div>
</template>

<script>
export default {
  name:'UsrInfView',
  props:['item'],
  computed:{
    SafeItem(){
        return this.item ||null
    }
  },
  data(){
    return {
        
    }
  },
  methods:{
    parentToshow(type){
      this.$emit('change-zhekou',this.SafeItem,type)
    }
  }
}
</script>

<style lang="scss" scoped>
.record-item{
    width: calc(90% - 40px);
    margin: 14px auto 0;
    background: rgb(0, 0, 0,.65);
    border-radius: 10px;
    padding: 10px 20px;
    text-align: left;
    ul {
        width: 100%;
        font-size: 16px;
        li {
            position: relative;
            border-bottom: 1px solid #3e435d;
            line-height: 2;
            a {
                position: absolute;
                right: 0;
            }
        }
    }
}
</style>
